module.exports = __webpack_public_path__ + "static/media/house-in-treeline.fcb06a48.jpg";